export default __webpack_public_path__ + "phonebook-search.346CS.jpg";